import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const getEpisodeContentId = (episode: LegacyEpisodePlayerBaseInfoContent) =>
    episode.episodeContentId ?? '';
